<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="shower"
        max-width="700px"
        persistent
        scrollable
        v-if="resolutionScreen >= 500"
      >
        <!-- <v-overlay :value="!loaddataprogress" z-index="3" color="black" dark>
        <v-progress-circular indeterminate size="64" color="white">
          <span :style="colorProgress"></span>
        </v-progress-circular>
        </v-overlay> -->
        <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>-->
        <v-card scrollable persistent>
          <v-card-title>
            <v-layout>
              <v-flex lg11 v-if="resolutionScreen >= 400">
                {{ $t("sharefile.messageboxheader") }}
              </v-flex>
              <v-flex lg11 xs10 v-else>
                {{ $t("sharefile.messageboxheader").substring(0, 20) }}
                <!-- {{ $t("sharefile.messageboxheader").substring(0, 20) + "..." }} -->
              </v-flex>
              <v-flex lg1 xs2 class="text-right"
                ><v-icon :color="color.theme" dense dark size="35"
                  >group_add</v-icon
                ></v-flex
              >
            </v-layout>
            <!-- {{ $t("sharefile.messageboxheader") }}<v-spacer></v-spacer>
            <v-icon :color="color.theme" dense dark size="35">group_add</v-icon> -->
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text style="height:440px" class="pt-4">
            <v-tabs v-model="opentabs" mobile-breakpoint class="elevation-2">
              <v-tab @click="opentabs = 0" class="pt-2">
                <!-- <v-badge
                  color="error"
                  :content="message.length"
                  v-if="message.length > 0"
                  >{{ $t("sharefile.personal") }}</v-badge
                >
                <div v-else>{{ $t("sharefile.personal") }}</div> -->
                <v-badge
                  color="error"
                  :content="listgroup_data.length"
                  v-if="listgroup_data.length > 0"
                  >{{ $t("sharefile.personal") }}</v-badge
                >
                <div v-else>{{ $t("sharefile.personal") }}</div>
                <!-- <div v-else>{{$t('sharefile.Email')}}</div> -->
              </v-tab>
              <!-- <v-tab @click="(opentabs = 1)">
                      <v-badge color="error" :content="messagetax.length" v-if="messagetax.length > 0"
                        >เลขประจำตัวผู้เสียภาษี (องค์กร)</v-badge
                      >
                      <v-div v-else>เลขประจำตัวผู้เสียภาษี (องค์กร)</v-div>
                    </v-tab> -->
              <v-tab @click="opentabs = 1" class="pt-2">
                <v-badge
                  color="error"
                  :content="messagetax.length"
                  v-if="messagetax.length > 0"
                >
                  {{ $t("sharefile.taxidbusiness") }}
                </v-badge>
                <div v-else>{{ $t("sharefile.taxidbusiness") }}</div>
              </v-tab>
              <v-tab-item>
                <v-container fluid>
                  <v-layout row wrap justify-center>
                    <v-flex lg4 md4 xs4 class="text-center mt-6 mr-1">
                      <v-select
                        outlined
                        dense
                        v-model="typeshare"
                        :items="listtypeshare"
                        item-value="listtypeshare_value"
                        :item-text="
                          $t('default') === 'th'
                            ? 'listtypeshare_type'
                            : 'listtypeshare_type_eng'
                        "
                        :label="$t('sharefile.type')"
                      ></v-select>
                    </v-flex>
                    <v-flex lg7 md7 xs7 class="text-center mt-6 pl-2">
                      <!-- แชร์อีเมลแบบเก่า -->
                      <!-- <v-text-field
                            v-model="email"
                            :label="$t('sharefile.Email')"
                            persistent-hint
                            multiple
                            outlined
                            dense
                            :disabled="!loaddataprogress"
                            :color="color.theme"
                          ></v-text-field> -->
                      <!-- แชร์แบบ type -->
                      <!-- {{typeshare_data}}
                          {{typeshare}} + TEST -->
                      <v-text-field
                        outlined
                        dense
                        :disabled="typeshare === ''"
                        v-model="typeshare_data"
                        :label="
                          typeshare === 'thai_email'
                            ? 'One Email'
                            : typeshare === 'username'
                            ? 'Username'
                            : typeshare === 'one_collab_mail'
                            ? 'One Collaboration Email'
                            : $t('default') === 'th'
                            ? 'กรุณาเลือกประเภทผู้ใช้งาน'
                            : 'Please select type'
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-center class="mt-n5">
                    <v-flex lg11 xs11>
                      <v-switch
                        v-model="switch1"
                        inset
                        :label="$t('sharefile.settime')"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg5 xs11 v-if="switch1 === true">
                      <v-dialog
                        persistent
                        v-model="modal"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            clearable
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            v-model="picker"
                            :label="$t('sharefile.setdate')"
                            readonly
                            prepend-icon="mdi-calendar"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="picker"
                          :min="datenow"
                          @input="modal = false"
                        >
                          <v-spacer></v-spacer>
                          <v-btn dark color="error" @click="modal = false">
                            {{ $t("sharefile.closedatepiker") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                                <v-divider vertical></v-divider>
                              </v-flex> -->
                    <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true ">
                                <v-icon>access_time</v-icon>
                              </v-flex> -->
                    <v-flex lg3 xs6 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.sethours')"
                        outlined
                        dense
                        :items="hours"
                        v-model="hour"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex lg3 xs5 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.setminute')"
                        outlined
                        dense
                        :items="minutes"
                        v-model="minute"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs11 class="text-left">
                      <v-subheader class="pl-1">{{
                        $t("sharefile.setpermissionsharefile")
                      }}</v-subheader>
                    </v-flex>
                    <v-flex lg7 xs6>
                      <v-select
                        v-model="status"
                        :items="values"
                        :label="$t('sharefile.Status')"
                        outlined
                        dense
                        class="elevation-0"
                        return-object
                        :color="color.theme"
                        :item-color="color.theme"
                      >
                        <template v-slot:item="{ item }">{{
                          $t(item.text)
                        }}</template>
                        <template v-slot:selection="{ item }">{{
                          $t(item.text)
                        }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex lg4 xs5 class="text-right">
                      <v-btn
                        :color="color.theme"
                        :dark="color.darkTheme"
                        :disabled="!loaddataprogress"
                        @click="addemail()"
                      >
                        {{ $t("sharefile.share") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 v-if="message.length !== 0">
                      <v-subheader class="ml-n3 mb-n2">{{
                        $t("sharefile.sharewith")
                      }}</v-subheader>
                    </v-flex>
                    <!-- loading -->
                    <v-progress-circular
                      v-if="loaddataprogress === false"
                      indeterminate
                      :color="color.theme"
                      size="100"
                    >
                      <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                    </v-progress-circular>
                    <!-- Share with -->
                    <v-flex lg11 xs11>
                      <v-layout
                        row
                        wrap
                        justify-left
                        pa-1
                        v-for="(item, i) in listgroup_data"
                        :key="i"
                        class="mb-n4"
                      >
                        <v-flex lg12 xs12 class=" mb-6">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex lg6 xs10 class="mb-3">
                          <!-- {{item.group_mail.type_shared}} -->
                          <v-text-field
                            :label="item.group_mail.type_shared === '0' ? 'Username' : item.group_mail.type_shared === '1' ? 'One Email' : 'One Collaboration Email'"
                            outlined
                            readonly
                            dense
                            v-model="item.group_mail.name_th"
                            hide-details
                            :color="color.theme"
                          ></v-text-field>
                          <!-- <v-text-field
                            v-else-if="type_shared === '1'"
                            label="One Email"
                            class="pl-2 pr-2"
                            outlined
                            readonly
                            dense
                            v-model="item.group_mail.name_th"
                            hide-details
                            :color="color.theme"
                          ></v-text-field> -->
                          <!-- <v-text-field
                            v-else-if="type_shared === '2'"
                            label="One Collaboration Email"
                            class="pl-2 pr-2"
                            outlined
                            readonly
                            dense
                            v-model="item.group_mail.name_th"
                            hide-details
                            :color="color.theme"
                          ></v-text-field> -->
                        </v-flex>
                        <!-- เพิ่ม check one collab -->
                        <v-flex
                          lg1
                          xs2
                          class="pt-2 text-left"
                          v-if="item.group_mail.type_shared === '3'"
                        >
                          <v-btn
                            class="elevation-0"
                            fab
                            x-small
                            v-model="item.group_mail.name_th"
                            @click="detail_group = false"
                            v-if="detail_group == true"
                          >
                            <v-icon>mdi-chevron-double-up</v-icon>
                          </v-btn>
                          <v-btn
                            class="elevation-0"
                            fab
                            x-small
                            v-model="item.group_mail.name_th"
                            @click="detail_group = true"
                            v-else
                          >
                            <v-icon>mdi-chevron-double-down</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex lg4 xs10 class="mb-3">
                          <v-select
                            class="pl-2"
                            :label="$t('sharefile.Status')"
                            hide-details
                            v-model="statusshare[i]"
                            :items="values"
                            outlined
                            dense
                            return-object
                            :color="color.theme"
                            :item-color="color.theme"
                          >
                            <template v-slot:item="{ item }">{{
                              $t(item.text)
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              $t(item.text)
                            }}</template>
                          </v-select>
                        </v-flex>
                        <!-- <pre>{{itemdelete}}</pre> -->
                        <v-flex lg2 xs2>
                          <!-- {{openconfirmcancelusersharefile}} -->
                          <div v-if="isItemDeleting(item.group_mail)" style="color: red">
                            <v-progress-circular
                              indeterminate
                              color="red"
                              size="16"
                              class="my-3 mx-1"
                            ></v-progress-circular>
                            {{ $t('sharefile.unsharing') }}
                          </div>
                          <v-icon
                            v-else
                            class="mx-4 mt-2"
                            color="red"
                            @click="
                              (itemdelete = item.group_mail),
                                (openconfirmcancelusersharefile = true)
                            "
                            >delete</v-icon
                          >
                        </v-flex>

                        <!-- เพิ่ม check one collab -->
                        <v-layout
                          row
                          wrap
                          justify-left
                          pa-1
                          class="mb-n4 ma-1"
                          v-if="detail_group == true"
                        >
                          <v-list>
                            <v-list-item
                              v-for="(itemm, i) in item.mail_list"
                              :key="i"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="itemm.name_th"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <!-- <v-flex lg6 xs8 class="mb-3 " >
                              <v-text-field
                                :label="$t('sharefile.Email')"
                                class="pl-2 pr-2"
                                outlined
                                readonly
                                dense
                                v-model="item.name_th"
                                hide-details
                                :color="color.theme"
                              ></v-text-field>
                            </v-flex> -->
                          <!-- <v-flex lg5 xs4 class="mb-3 "> -->
                          <!-- {{statusshare[i]}} -->
                          <!-- {{item}} -->
                          <!-- <v-text-field
                                class="pl-2 pr-2"
                                :label="$t('sharefile.Status')"
                                outlined
                                readonly
                                dense
                                v-model="item.status"
                                hide-details
                                return-object
                                :color="color.theme"
                                :item-color="color.theme"
                              >
                            </v-text-field> -->
                          <!-- <v-select
                                class="pl-2"
                                :label="$t('sharefile.Status')"
                                hide-details
                                v-model="statusshare_[i]"
                                :items="values"
                                outlined
                                dense
                                return-object
                                disabled
                                append-icon
                                :color="color.theme"
                                :item-color="color.theme"
                              >
                                <template v-slot:item="{ item }">{{ $t(item.text) }}</template>
                                <template v-slot:selection="{ item }">{{ $t(item.text) }}</template>
                              </v-select>
                            </v-flex> -->
                        </v-layout>

                        <v-flex lg6 xs12 class="mb-n3 mt-2">
                          <v-dialog
                            persistent
                            v-model="emailformdate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                clearable
                                :label="$t('sharefile.setdate')"
                                :value="
                                  picker2[i] === '' || null
                                    ? setdate(item.group_mail.number_of_days)
                                    : formatdatetextfield(picker2[i])
                                "
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                class="pl-2 pr-2"
                                @click="checkpicker = i"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="picker2[checkpicker]"
                              :min="datenow"
                              @input="emailformdate = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="emailformdate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <!-- <v-flex lg1 class="pl-5 pt-3" v-if="resolutionScreen > 500">
                                    <v-divider vertical></v-divider>
                                  </v-flex> -->
                        <!-- <v-flex lg1 xs1 >
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
                        <v-flex lg3 xs6 class="mt-2">
                          <v-select
                            :label="$t('sharefile.sethours')"
                            class="pl-2 pr-1"
                            :items="hours"
                            v-model="hour2[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                        <v-flex lg3 xs6 class="mt-2">
                          <v-select
                            class=" pr-2"
                            :label="$t('sharefile.setminute')"
                            :items="minutes"
                            v-model="minute2[i]"
                            dense
                            outlined
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <!-- {{opentabs}} -->
                <v-container fluid>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs11 class="text-center mt-6">
                      <v-text-field
                        v-model="taxid"
                        :disabled="!loaddataprogress"
                        :label="$t('TaxID')"
                        persistent-hint
                        multiple
                        outlined
                        dense
                        :color="color.theme"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center class="mt-n5">
                    <v-flex lg11 xs11>
                      <v-switch
                        v-model="switch1"
                        inset
                        :label="$t('sharefile.settime')"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg5 xs11 v-if="switch1 === true">
                      <v-dialog
                        persistent
                        v-model="modal2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            v-model="picker"
                            :label="$t('sharefile.setdate')"
                            readonly
                            prepend-icon="mdi-calendar"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="picker"
                          :min="datenow"
                          @input="modal2 = false"
                        >
                          <v-spacer></v-spacer>
                          <v-btn dark color="error" @click="modal2 = false">
                            {{ $t("sharefile.closedatepiker") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                                <v-divider vertical></v-divider>
                              </v-flex> -->
                    <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true">
                                <v-icon>access_time</v-icon>
                              </v-flex> -->
                    <v-flex lg3 xs6 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.sethours')"
                        outlined
                        dense
                        :items="hours"
                        v-model="hour"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex lg3 xs5 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.setminute')"
                        outlined
                        dense
                        :items="minutes"
                        v-model="minute"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs11 class="text-left mb-2">
                      <v-subheader class="pl-1">{{
                        $t("sharefile.setpermissionsharefile")
                      }}</v-subheader>
                    </v-flex>
                    <v-flex lg7 xs6>
                      <v-select
                        v-model="status"
                        :items="values"
                        :label="$t('sharefile.Status')"
                        text
                        dense
                        return-object
                        :color="color.theme"
                        :item-color="color.theme"
                        outlined
                      >
                        <template v-slot:item="{ item }">{{
                          $t(item.text)
                        }}</template>
                        <template v-slot:selection="{ item }">{{
                          $t(item.text)
                        }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex lg4 xs5 class="text-right">
                      <v-btn
                        :color="color.theme"
                        :dark="color.darkTheme"
                        :disabled="!loaddataprogress"
                        @click="checktaxid()"
                      >
                        {{ $t("sharefile.share") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 v-if="messagetax.length !== 0">
                      <v-subheader class="ml-n3 mb-n2">{{
                        $t("sharefile.sharewith")
                      }}</v-subheader>
                    </v-flex>
                    <!-- loadingtax -->
                    <v-progress-circular
                      v-if="loaddataprogress === false"
                      indeterminate
                      :color="color.theme"
                      size="100"
                    >
                      <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                    </v-progress-circular>
                    <!-- Share with tax-->
                    <v-flex lg11 xs11>
                      <v-layout
                        row
                        wrap
                        justify-center
                        pa-1
                        v-for="(item, i) in messagetax"
                        :key="i"
                        class="mb-n4"
                      >
                        <v-flex lg12 xs12 class=" mb-6">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex lg6 xs12 class="mb-3">
                          <v-text-field
                            class="pl-2 pr-2"
                            v-if="$t('default') === 'th'"
                            v-model="item.name_th"
                            outlined
                            readonly
                            dense
                            hide-details
                            :color="color.theme"
                            :label="$t('sharefile.business')"
                          ></v-text-field>
                          <v-text-field
                            class="pl-2 pr-2"
                            v-else
                            v-model="item.name_eng"
                            outlined
                            readonly
                            dense
                            hide-details
                            :color="color.theme"
                            :label="$t('sharefile.business')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs10 class="mb-3">
                          <v-select
                            class="pl-2"
                            hide-details
                            :items="values"
                            :label="$t('sharefile.Status')"
                            v-model="statussharetax[i]"
                            outlined
                            dense
                            return-object
                            :color="color.theme"
                            :item-color="color.theme"
                          >
                            <template v-slot:item="{ item }">{{
                              $t(item.text)
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              $t(item.text)
                            }}</template>
                          </v-select>
                        </v-flex>
                        <v-flex lg2 xs2>
                          <div v-if="isItemDeleting(item)" style="color: red">
                            <v-progress-circular
                              indeterminate
                              color="red"
                              size="16"
                              class="my-3 mx-1"
                            ></v-progress-circular>
                            {{ $t('sharefile.unsharing') }}
                          </div>
                          <v-icon
                            v-else
                            class="mx-4 mt-2"
                            color="red"
                            @click="
                              (itemdelete = item),
                                (openconfirmcancelusersharefile = true)
                            "
                            >delete</v-icon
                          >
                        </v-flex>
                        <v-flex lg6 xs12 class="mb-n3">
                          <v-dialog
                            persistent
                            v-model="taxfromdate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="
                                  pickertax[i] === '' || null
                                    ? setdate(item.number_of_days)
                                    : formatdatetextfield(pickertax[i])
                                "
                                :label="$t('sharefile.setdate')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                clearable
                                v-on="on"
                                outlined
                                dense
                                class="pl-2 pr-2"
                                @click="checkpicker = i"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="pickertax[checkpicker]"
                              :min="datenow"
                              @input="taxfromdate = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="taxfromdate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <!-- <v-flex lg1 class="pl-6 pt-3">
                                    <v-divider vertical></v-divider>
                                  </v-flex> -->
                        <!-- <v-flex lg1 xs1 class="pt-4 pl-2" >
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
                        <v-flex lg3 xs6>
                          <v-select
                            :label="$t('sharefile.sethours')"
                            class="pl-2 pr-1"
                            :items="hours"
                            v-model="hourtax[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                        <v-flex lg3 xs6>
                          <v-select
                            class=" pr-2"
                            :label="$t('sharefile.setminute')"
                            :items="minutes"
                            v-model="minutetax[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="opentabs === 0">
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="
                closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = []),
                  statusclosereload === false ? $emit('close') : $emit('closesharefile')
              "
              :disabled="deletingItems.length > 0"
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              :color="color.theme"
              class="white--text"
              :disabled="checkbuttonupdate || deletingItems.length > 0"
              @click="editapi()"
              :loading="processloading"
              >{{ $t("sharefile.oksharefile") }}</v-btn
            >
          </v-card-actions>

          <v-card-actions v-if="opentabs === 1">
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="
                closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = []),
                  statusclosereload === false ? $emit('close') : $emit('closesharefile')
              "
              :disabled="deletingItems.length > 0"
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              :color="color.theme"
              class="white--text"
              :disabled="checkbuttonupdate || deletingItems.length > 0"
              @click="editapi()"
              :loading="processloading"
              >{{ $t("sharefile.oksharefile") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- หน้าจอมือถือใหม่ -->
      <v-dialog
        v-else
        v-model="shower"
        persistent
        scrollable
        :width="maxWidthOnMobile"
        content-class="rounded-lg ma-0"
      >
        <v-card class="pa-0">
          <v-card-text class="pa-5">
            <v-layout class="pt-2 pb-1">
              <v-flex d-flex justify-center class="ml-8">
                <span :style="headerPage">{{
                  $t("sharefile.messageboxheader").substring(0, 20)
                }}</span>
              </v-flex>
              <v-flex xs1 d-flex justify-end>
                <v-icon
                  :color="$vuetify.theme.dark ? 'white' : color.theme"
                  @click="
                    $emit('close'),
                      closevalues(),
                      (setdatetime = []),
                      (minute2 = []),
                      (minutetax = []),
                      (hour2 = []),
                      (hourtax = []),
                      (picker = ''),
                      (minute = ''),
                      (hour = ''),
                      (switch1 = false),
                      (message = []),
                      (messagetax = [])
                  "
                  >mdi-close</v-icon
                >
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-tabs fixed-tabs v-model="opentabs">
            <v-tab @click="opentabs = 0" class="pt-2">
              <!-- <v-badge
                color="error"
                :content="message.length"
                v-if="message.length > 0"
                >{{ $t("sharefile.personal") }}</v-badge
              >
              <div v-else style="font-size:12px">
                {{ $t("sharefile.personal") }}
              </div> -->
              <v-badge
                color="error"
                :content="listgroup_data.length"
                v-if="listgroup_data.length > 0"
                >{{ $t("sharefile.personal") }}</v-badge
              >
              <div v-else style="font-size:12px">
                {{ $t("sharefile.personal") }}
              </div>
              <!-- <div v-else>{{$t('sharefile.Email')}}</div> -->
            </v-tab>
            <v-tab @click="opentabs = 1" class="pt-2">
              <v-badge
                color="error"
                :content="messagetax.length"
                v-if="messagetax.length > 0"
              >
                {{ $t("sharefile.taxidbusiness") }}
              </v-badge>
              <div v-else style="font-size:12px">
                {{ $t("sharefile.taxidbusiness") }}
              </div>
            </v-tab>
            <v-tab-item class="scroller">
              <v-container fluid>
                <v-layout row wrap justify-center>
                  <v-flex lg4 md4 xs9 class="text-center mt-6">
                    <v-select
                      outlined
                      dense
                      v-model="typeshare"
                      :items="listtypeshare"
                      item-value="listtypeshare_value"
                      :item-text="
                        $t('default') === 'th'
                          ? 'listtypeshare_type'
                          : 'listtypeshare_type_eng'
                      "
                      :label="$t('sharefile.type')"
                    ></v-select>
                  </v-flex>
                  <v-flex lg7 md7 xs9 class="text-center">
                    <v-text-field
                      outlined
                      dense
                      :disabled="typeshare === ''"
                      v-model="typeshare_data"
                      :label="
                        typeshare === 'thai_email'
                          ? 'One Email'
                          : typeshare === 'username'
                          ? 'Username'
                          : typeshare === 'one_collab_mail'
                          ? 'One Collaboration Email'
                          : $t('default') === 'th'
                          ? 'กรุณาเลือกประเภทผู้ใช้งาน'
                          : 'Please select type'
                      "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center class="mt-n5">
                  <v-flex lg11 xs10>
                    <v-switch
                      v-model="switch1"
                      :label="$t('sharefile.settime')"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg5 xs9 v-if="switch1 === true">
                    <v-dialog
                      persistent
                      v-model="modal"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          clearable
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                          v-model="picker"
                          :label="$t('sharefile.setdate')"
                          readonly
                          prepend-icon="mdi-calendar"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="picker"
                        :min="datenow"
                        @input="modal = false"
                      >
                        <v-spacer></v-spacer>
                        <v-btn dark color="error" @click="modal = false">
                          {{ $t("sharefile.closedatepiker") }}
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                              <v-divider vertical></v-divider>
                            </v-flex> -->
                  <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true ">
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
                  <v-flex lg3 xs5 v-if="switch1 === true">
                    <v-select
                      class="pl-1"
                      :label="$t('sharefile.sethours')"
                      outlined
                      dense
                      :items="hours"
                      v-model="hour"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex lg3 xs4 v-if="switch1 === true">
                    <v-select
                      class="pl-1"
                      :label="$t('sharefile.setminute')"
                      outlined
                      dense
                      :items="minutes"
                      v-model="minute"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg11 xs10 class="text-left">
                    <v-subheader class="pl-1">{{
                      $t("sharefile.setpermissionsharefile")
                    }}</v-subheader>
                  </v-flex>
                  <v-flex lg7 xs6 class="ml-2 pl-4">
                    <v-select
                      v-model="status"
                      :items="values"
                      :label="$t('sharefile.Status')"
                      outlined
                      dense
                      class="elevation-0"
                      return-object
                      :color="color.theme"
                      :item-color="color.theme"
                    >
                      <template v-slot:item="{ item }">{{
                        $t(item.text)
                      }}</template>
                      <template v-slot:selection="{ item }">{{
                        $t(item.text)
                      }}</template>
                    </v-select>
                  </v-flex>
                  <v-flex lg4 xs4 class="text-right mr-5 pr-2">
                    <v-btn
                      :color="color.theme"
                      :dark="color.darkTheme"
                      :disabled="!loaddataprogress"
                      @click="addemail()"
                    >
                      {{ $t("sharefile.share") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg11 xs10 v-if="message.length !== 0">
                    <v-subheader class="ml-n3 mb-n2">{{
                      $t("sharefile.sharewith")
                    }}</v-subheader>
                  </v-flex>
                  <!-- loading -->
                  <v-progress-circular
                    v-if="loaddataprogress === false"
                    indeterminate
                    :color="color.theme"
                    size="100"
                  >
                    <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                  </v-progress-circular>
                  <!-- Share with -->
                  <v-flex lg11 xs9>
                    <v-layout
                      row
                      wrap
                      justify-left
                      pa-1
                      v-for="(item, i) in listgroup_data"
                      :key="i"
                      class="mb-n4"
                    >
                      <v-flex lg12 xs12 class=" mb-6">
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex lg5 xs11 class="mb-2">
                        <v-text-field
                          :label="$t('sharefile.Email')"
                          class="pl-1 pr-2"
                          outlined
                          readonly
                          dense
                          v-model="item.group_mail.name_th"
                          hide-details
                          :color="color.theme"
                        ></v-text-field>
                      </v-flex>
                      <!-- เพิ่ม check one collab -->
                      <v-flex
                        lg1
                        xs1
                        class="pt-2 text-center"
                        v-if="item.group_mail.type_shared === '3'"
                      >
                        <v-btn
                          class="elevation-0"
                          fab
                          x-small
                          v-model="item.group_mail.name_th"
                          @click="detail_group = false"
                          v-if="detail_group == true"
                        >
                          <v-icon>mdi-chevron-double-up</v-icon>
                        </v-btn>
                        <v-btn
                          class="elevation-0"
                          fab
                          x-small
                          v-model="item.group_mail.name_th"
                          @click="detail_group = true"
                          v-else
                        >
                          <v-icon>mdi-chevron-double-down</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex lg4 xs7 class="mb-3">
                        <v-select
                          class="pl-1"
                          :label="$t('sharefile.Status')"
                          hide-details
                          v-model="statusshare[i]"
                          :items="values"
                          outlined
                          dense
                          return-object
                          :color="color.theme"
                          :item-color="color.theme"
                        >
                          <template v-slot:item="{ item }">{{
                            $t(item.text)
                          }}</template>
                          <template v-slot:selection="{ item }">{{
                            $t(item.text)
                          }}</template>
                        </v-select>
                      </v-flex>
                      <!-- <pre>{{itemdelete}}</pre> -->
                      <v-flex lg1 xs5 class="pt-2 text-center">
                        <!-- {{openconfirmcancelusersharefile}} -->
                        <div v-if="isItemDeleting(item.group_mail)" style="color: red">
                          <v-progress-circular
                            indeterminate
                            color="red"
                            size="16"
                            class="my-3 mx-1"
                          ></v-progress-circular>
                          {{ $t('sharefile.unsharing') }}
                        </div>
                        <v-icon
                          v-else
                          class="mx-4 mt-2"
                          color="red"
                          @click="
                            (itemdelete = item.group_mail),
                              (openconfirmcancelusersharefile = true)
                          "
                          >delete</v-icon
                        >
                      </v-flex>
                      <!-- เพิ่ม check one collab -->
                      <v-layout
                        row
                        wrap
                        justify-left
                        pa-1
                        class="mb-n4 ma-1"
                        v-if="detail_group == true"
                      >
                        <v-list>
                          <v-list-item
                            v-for="(itemm, i) in item.mail_list"
                            :key="i"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                v-text="itemm.name_th"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-layout>
                      <v-flex lg6 xs12 class="mb-n3">
                        <v-dialog
                          persistent
                          v-model="emailformdate"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              clearable
                              :label="$t('sharefile.setdate')"
                              :value="
                                picker2[i] === '' || null
                                  ? setdate(item.group_mail.number_of_days)
                                  : formatdatetextfield(picker2[i])
                              "
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              outlined
                              dense
                              class="pl-1 pr-2"
                              @click="checkpicker = i"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="picker2[checkpicker]"
                            :min="datenow"
                            @input="emailformdate = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              color="error"
                              @click="emailformdate = false"
                            >
                              {{ $t("sharefile.closedatepiker") }}
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <!-- <v-flex lg1 class="pl-5 pt-3" v-if="resolutionScreen > 500">
                                  <v-divider vertical></v-divider>
                                </v-flex> -->
                      <!-- <v-flex lg1 xs1 >
                            <v-icon>access_time</v-icon>
                          </v-flex> -->
                      <v-flex lg3 xs6>
                        <v-select
                          :label="$t('sharefile.sethours')"
                          class="pl-0 pr-0"
                          :items="hours"
                          v-model="hour2[i]"
                          outlined
                          dense
                        >
                        </v-select>
                      </v-flex>
                      <v-flex lg3 xs5 ml-1>
                        <v-select
                          class="pl-0 ml-0"
                          :label="$t('sharefile.setminute')"
                          :items="minutes"
                          v-model="minute2[i]"
                          dense
                          outlined
                        >
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item class="scroller">
              <v-container fluid>
                <v-layout row wrap justify-center>
                  <v-flex lg11 xs9 class="text-center mt-6">
                    <v-text-field
                      v-model="taxid"
                      :disabled="!loaddataprogress"
                      :label="$t('TaxID')"
                      persistent-hint
                      multiple
                      outlined
                      dense
                      :color="color.theme"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center class="mt-n5">
                  <v-flex lg11 xs10>
                    <v-switch
                      v-model="switch1"
                      :label="$t('sharefile.settime')"
                    >
                    </v-switch>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg5 xs9 v-if="switch1 === true">
                    <v-dialog
                      persistent
                      v-model="modal2"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          v-model="picker"
                          :label="$t('sharefile.setdate')"
                          readonly
                          prepend-icon="mdi-calendar"
                          outlined
                          dense
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="picker"
                        :min="datenow"
                        @input="modal2 = false"
                      >
                        <v-spacer></v-spacer>
                        <v-btn dark color="error" @click="modal2 = false">
                          {{ $t("sharefile.closedatepiker") }}
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                              <v-divider vertical></v-divider>
                            </v-flex> -->
                  <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true">
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
                            <!-- :label="$t('sharefile.sethours')"sethours -->
                  <v-flex lg3 xs5 v-if="switch1 === true">
                    <v-select
                      class="pl-1"
                      :label="$t('sharefile.settime')"
                      outlined
                      dense
                      :items="hours"
                      v-model="hour"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex lg3 xs4 v-if="switch1 === true">
                    <v-select
                      class="pl-1"
                      :label="$t('sharefile.setminute')"
                      outlined
                      dense
                      :items="minutes"
                      v-model="minute"
                    >
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg11 xs10 class="text-left mb-2">
                    <v-subheader class="pl-1">{{
                      $t("sharefile.setpermissionsharefile")
                    }}</v-subheader>
                  </v-flex>
                  <v-flex lg7 xs6 class="ml-2 pl-4">
                    <v-select
                      v-model="status"
                      :items="values"
                      :label="$t('sharefile.Status')"
                      text
                      dense
                      return-object
                      :color="color.theme"
                      :item-color="color.theme"
                      outlined
                    >
                      <template v-slot:item="{ item }">{{
                        $t(item.text)
                      }}</template>
                      <template v-slot:selection="{ item }">{{
                        $t(item.text)
                      }}</template>
                    </v-select>
                  </v-flex>
                  <v-flex lg4 xs4 class="text-right mr-5 pr-2">
                    <v-btn
                      :color="color.theme"
                      :dark="color.darkTheme"
                      :disabled="!loaddataprogress"
                      @click="checktaxid()"
                    >
                      {{ $t("sharefile.share") }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-center>
                  <v-flex lg11 xs10 v-if="messagetax.length !== 0">
                    <v-subheader class="ml-n3 mb-n2">{{
                      $t("sharefile.sharewith")
                    }}</v-subheader>
                  </v-flex>
                  <!-- loadingtax -->
                  <v-progress-circular
                    v-if="loaddataprogress === false"
                    indeterminate
                    :color="color.theme"
                    size="100"
                  >
                    <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                  </v-progress-circular>
                  <!-- Share with tax-->
                  <v-flex lg11 xs9>
                    <v-layout
                      row
                      wrap
                      justify-center
                      pa-1
                      v-for="(item, i) in messagetax"
                      :key="i"
                      class="mb-n4"
                    >
                      <v-flex lg12 xs12 class=" mb-6">
                        <v-divider></v-divider>
                      </v-flex>
                      <v-flex lg7 xs12 class="mb-3">
                        <v-text-field
                          class="pl-2 pr-2"
                          v-if="$t('default') === 'th'"
                          v-model="item.name_th"
                          outlined
                          readonly
                          dense
                          hide-details
                          :color="color.theme"
                          :label="$t('sharefile.business')"
                        ></v-text-field>
                        <v-text-field
                          class="pl-2 pr-2"
                          v-else
                          v-model="item.name_eng"
                          outlined
                          readonly
                          dense
                          hide-details
                          :color="color.theme"
                          :label="$t('sharefile.business')"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg4 xs7 class="mb-3">
                        <v-select
                          class="pl-2"
                          hide-details
                          :items="values"
                          :label="$t('sharefile.Status')"
                          v-model="statussharetax[i]"
                          outlined
                          dense
                          return-object
                          :color="color.theme"
                          :item-color="color.theme"
                        >
                          <template v-slot:item="{ item }">{{
                            $t(item.text)
                          }}</template>
                          <template v-slot:selection="{ item }">{{
                            $t(item.text)
                          }}</template>
                        </v-select>
                      </v-flex>
                      <v-flex lg1 xs5 class="pt-2 text-center">
                        <div v-if="isItemDeleting(item)" style="color: red">
                          <v-progress-circular
                            indeterminate
                            color="red"
                            size="16"
                            class="my-3 mx-1"
                          ></v-progress-circular>
                          {{ $t('sharefile.unsharing') }}
                        </div>
                        <v-icon
                          v-else
                          class="mx-4 mt-2"
                          color="red"
                          @click="
                            (itemdelete = item),
                              (openconfirmcancelusersharefile = true)
                          "
                        >delete</v-icon
                      >
                      </v-flex>
                      <v-flex lg6 xs12 class="mb-n3">
                        <v-dialog
                          persistent
                          v-model="taxfromdate"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="
                                pickertax[i] === '' || null
                                  ? setdate(item.number_of_days)
                                  : formatdatetextfield(pickertax[i])
                              "
                              :label="$t('sharefile.setdate')"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              clearable
                              v-on="on"
                              outlined
                              dense
                              class="pl-2 pr-2"
                              @click="checkpicker = i"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="pickertax[checkpicker]"
                            :min="datenow"
                            @input="taxfromdate = false"
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              color="error"
                              @click="taxfromdate = false"
                            >
                              {{ $t("sharefile.closedatepiker") }}
                            </v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <!-- <v-flex lg1 class="pl-6 pt-3">
                                  <v-divider vertical></v-divider>
                                </v-flex> -->
                      <!-- <v-flex lg1 xs1 class="pt-4 pl-2" >
                            <v-icon>access_time</v-icon>
                          </v-flex> -->
                      <v-flex lg3 xs6>
                        <v-select
                          :label="$t('sharefile.sethours')"
                          class="pl-0 pr-0"
                          :items="hours"
                          v-model="hourtax[i]"
                          outlined
                          dense
                        >
                        </v-select>
                      </v-flex>
                      <v-flex lg3 xs5 ml-1>
                        <v-select
                          class=" pr-0"
                          :label="$t('sharefile.setminute')"
                          :items="minutes"
                          v-model="minutetax[i]"
                          outlined
                          dense
                        >
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
          <div v-if="opentabs === 0" class="text-center my-4">
            <v-btn
              class="mr-2"
              height="40px"
              width="40%"
              color="red"
              outlined
              @click="
                closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = []),
                  statusclosereload === false ? $emit('close') : $emit('closesharefile')
              "
              :disabled="deletingItems.length > 0"
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              class="elevation-0 white--text"
              :style="btnAction"
              height="40px"
              width="40%"
              :color="color.theme"
              :disabled="checkbuttonupdate || deletingItems.length > 0"
              @click="editapi()"
              :loading="processloading"
            >
              {{ $t("sharefile.oksharefile") }}
            </v-btn>
          </div>
          <div v-if="opentabs === 1" class="text-center my-4">
            <v-btn
              class="mr-2"
              height="40px"
              width="40%"
              color="red"
              outlined
              @click="
                closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = []),
                  statusclosereload === false ? $emit('close') : $emit('closesharefile')
              "
              :disabled="deletingItems.length > 0"
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              class="elevation-0 white--text"
              :style="btnAction"
              height="40px"
              width="40%"
              :color="color.theme"
              :disabled="checkbuttonupdate || deletingItems.length > 0"
              @click="editapi()"
              :loading="processloading"
            >
              {{ $t("sharefile.oksharefile") }}
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
      <!-- หน้าจอมือถือเก่า -->
      <!-- <v-dialog v-model="shower" max-width="500px" persistent scrollable v-else> -->
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>-->
      <!-- <v-card scrollable persistent>
          <v-card-title>
            <v-layout>
              <v-flex lg11 xs10 style="font-size:15px">
                {{ $t("sharefile.messageboxheader").substring(0, 20) }} -->
      <!-- {{ $t("sharefile.messageboxheader").substring(0, 20) + "..." }} -->
      <!-- </v-flex>
              <v-flex lg1 xs2 class="text-right"
                ><v-icon :color="color.theme" dense dark size="28"
                  >group_add</v-icon
                ></v-flex
              >
            </v-layout> -->
      <!-- {{ $t("sharefile.messageboxheader") }}<v-spacer></v-spacer>
            <v-icon :color="color.theme" dense dark size="35">group_add</v-icon> -->
      <!-- </v-card-title>
          <v-divider></v-divider>

          <v-card-text style="height:420px" class="pt-4">
            <v-tabs v-model="opentabs" mobile-breakpoint class="elevation-2">
              <v-tab @click="opentabs = 0" class="pt-2">
                <v-badge
                  color="error"
                  :content="message.length"
                  v-if="message.length > 0"
                  >{{ $t("sharefile.personal") }}</v-badge
                >
                <div v-else style="font-size:12px">
                  {{ $t("sharefile.personal") }}
                </div> -->
      <!-- <div v-else>{{$t('sharefile.Email')}}</div> -->
      <!-- </v-tab> -->
      <!-- <v-tab @click="(opentabs = 1)">
                      <v-badge color="error" :content="messagetax.length" v-if="messagetax.length > 0"
                        >เลขประจำตัวผู้เสียภาษี (องค์กร)</v-badge
                      >
                      <v-div v-else>เลขประจำตัวผู้เสียภาษี (องค์กร)</v-div>
                    </v-tab> -->
      <!-- <v-tab @click="opentabs = 1" class="pt-2">
                <v-badge
                  color="error"
                  :content="messagetax.length"
                  v-if="messagetax.length > 0"
                >
                  {{ $t("sharefile.taxidbusiness") }}
                </v-badge>

                <div v-else style="font-size:12px">
                  {{ $t("sharefile.taxidbusiness") }}
                </div>
              </v-tab>
              <v-tab-item> -->
      <!-- {{opentabs}} -->
      <!-- <v-container fluid>
                  <v-layout row wrap justify-center>
                    <v-flex lg4 md4 xs9 class="text-center mt-6">
                      <v-select
                        outlined
                        dense
                        v-model="typeshare"
                        :items="listtypeshare"
                        item-value="listtypeshare_value"
                        :item-text="
                          $t('default') === 'th'
                            ? 'listtypeshare_type'
                            : 'listtypeshare_type_eng'
                        "
                        :label="$t('sharefile.type')"
                      ></v-select>
                    </v-flex>
                    <v-flex lg7 md7 xs9 class="text-center">
                      <v-text-field
                        outlined
                        dense
                        :disabled="typeshare === ''"
                        v-model="typeshare_data"
                        :label="
                          typeshare === 'thai_email'
                            ? 'Email'
                            : typeshare === 'username'
                            ? 'Username'
                            : typeshare === 'one_collab_mail'
                            ? 'One Collaboration Email'
                            : $t('default') === 'th'
                            ? 'กรุณาเลือกประเภทผู้ใช้งาน'
                            : 'Please select type'
                        "
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center class="mt-n5">
                    <v-flex lg11 xs10>
                      <v-switch
                        v-model="switch1"
                        :label="$t('sharefile.settime')"
                      ></v-switch>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-center>
                    <v-flex lg5 xs9 v-if="switch1 === true">
                      <v-dialog
                        persistent
                        v-model="modal"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            clearable
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                            v-model="picker"
                            :label="$t('sharefile.setdate')"
                            readonly
                            prepend-icon="mdi-calendar"
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="picker"
                          :min="datenow"
                          @input="modal = false"
                        >
                          <v-spacer></v-spacer>
                          <v-btn dark color="error" @click="modal = false">
                            {{ $t("sharefile.closedatepiker") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex> -->
      <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                                <v-divider vertical></v-divider>
                              </v-flex> -->
      <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true ">
                                <v-icon>access_time</v-icon>
                              </v-flex> -->
      <!-- <v-flex lg3 xs5 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.sethours')"
                        outlined
                        dense
                        :items="hours"
                        v-model="hour"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex lg3 xs4 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.setminute')"
                        outlined
                        dense
                        :items="minutes"
                        v-model="minute"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 class="text-left">
                      <v-subheader class="pl-1">{{
                        $t("sharefile.setpermissionsharefile")
                      }}</v-subheader>
                    </v-flex>
                    <v-flex lg7 xs6 class="ml-2 pl-4">
                      <v-select
                        v-model="status"
                        :items="values"
                        :label="$t('sharefile.Status')"
                        outlined
                        dense
                        class="elevation-0"
                        return-object
                        :color="color.theme"
                        :item-color="color.theme"
                      >
                        <template v-slot:item="{ item }">{{
                          $t(item.text)
                        }}</template>
                        <template v-slot:selection="{ item }">{{
                          $t(item.text)
                        }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex lg4 xs4 class="text-right mr-5 pr-2">
                      <v-btn
                        :color="color.theme"
                        :dark="color.darkTheme"
                        :disabled="!loaddataprogress"
                        @click="addemail()"
                      >
                        {{ $t("sharefile.share") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 v-if="message.length !== 0">
                      <v-subheader class="ml-n3 mb-n2">{{
                        $t("sharefile.sharewith")
                      }}</v-subheader>
                    </v-flex> -->
      <!-- loading -->
      <!-- <v-progress-circular
                      v-if="loaddataprogress === false"
                      indeterminate
                      :color="color.theme"
                      size="100"
                    >
                      <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                    </v-progress-circular> -->
      <!-- Share with -->
      <!-- <v-flex lg11 xs9>
                      <v-layout
                        row
                        wrap
                        justify-left
                        pa-1
                        v-for="(item, i) in listgroup_data"
                        :key="i"
                        class="mb-n4"
                      >
                        <v-flex lg12 xs12 class=" mb-6">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex lg5 xs11 class="mb-2">
                          <v-text-field
                            :label="$t('sharefile.Email')"
                            class="pl-1 pr-2"
                            outlined
                            readonly
                            dense
                            v-model="item.group_mail.name_th"
                            hide-details
                            :color="color.theme"
                          ></v-text-field>
                        </v-flex> -->
      <!-- เพิ่ม check one collab -->
      <!-- <v-flex
                          lg1
                          xs1
                          class="pt-2 text-center"
                          v-if="item.group_mail.type_shared === '3'"
                        >
                          <v-btn
                            class="elevation-0"
                            fab
                            x-small
                            v-model="item.group_mail.name_th"
                            @click="detail_group = false"
                            v-if="detail_group == true"
                          >
                            <v-icon>mdi-chevron-double-up</v-icon>
                          </v-btn>
                          <v-btn
                            class="elevation-0"
                            fab
                            x-small
                            v-model="item.group_mail.name_th"
                            @click="detail_group = true"
                            v-else
                          >
                            <v-icon>mdi-chevron-double-down</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex lg4 xs7 class="mb-3">
                          <v-select
                            class="pl-1"
                            :label="$t('sharefile.Status')"
                            hide-details
                            v-model="statusshare[i]"
                            :items="values"
                            outlined
                            dense
                            return-object
                            :color="color.theme"
                            :item-color="color.theme"
                          >
                            <template v-slot:item="{ item }">{{
                              $t(item.text)
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              $t(item.text)
                            }}</template>
                          </v-select>
                        </v-flex> -->
      <!-- <pre>{{itemdelete}}</pre> -->
      <!-- <v-flex lg1 xs5 class="pt-2 text-center"> -->
      <!-- {{openconfirmcancelusersharefile}} -->

      <!-- <v-icon
                            color="red"
                            @click="
                              (itemdelete = item.group_mail),
                                (openconfirmcancelusersharefile = true)
                            "
                            >delete</v-icon
                          >
                        </v-flex> -->

      <!-- เพิ่ม check one collab -->
      <!-- <v-layout
                          row
                          wrap
                          justify-left
                          pa-1
                          class="mb-n4 ma-1"
                          v-if="detail_group == true"
                        >
                          <v-list>
                            <v-list-item
                              v-for="(itemm, i) in item.mail_list"
                              :key="i"
                            >
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="itemm.name_th"
                                ></v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-layout>
                        <v-flex lg6 xs12 class="mb-n3">
                          <v-dialog
                            persistent
                            v-model="emailformdate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                clearable
                                :label="$t('sharefile.setdate')"
                                :value="
                                  picker2[i] === '' || null
                                    ? setdate(item.group_mail.number_of_days)
                                    : formatdatetextfield(picker2[i])
                                "
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                dense
                                class="pl-1 pr-2"
                                @click="checkpicker = i"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="picker2[checkpicker]"
                              :min="datenow"
                              @input="emailformdate = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="emailformdate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex> -->
      <!-- <v-flex lg1 class="pl-5 pt-3" v-if="resolutionScreen > 500">
                                    <v-divider vertical></v-divider>
                                  </v-flex> -->
      <!-- <v-flex lg1 xs1 >
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
      <!-- <v-flex lg3 xs6>
                          <v-select
                            :label="$t('sharefile.sethours')"
                            class="pl-0 pr-0"
                            :items="hours"
                            v-model="hour2[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                        <v-flex lg3 xs5 ml-1>
                          <v-select
                            class="pl-0 ml-0"
                            :label="$t('sharefile.setminute')"
                            :items="minutes"
                            v-model="minute2[i]"
                            dense
                            outlined
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
              <v-tab-item> -->
      <!-- {{opentabs}} -->
      <!-- <v-container fluid>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs9 class="text-center mt-6">
                      <v-text-field
                        v-model="taxid"
                        :disabled="!loaddataprogress"
                        :label="$t('TaxID')"
                        persistent-hint
                        multiple
                        outlined
                        dense
                        :color="color.theme"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center class="mt-n5">
                    <v-flex lg11 xs10>
                      <v-switch
                        v-model="switch1"
                        :label="$t('sharefile.settime')"
                      >
                      </v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg5 xs9 v-if="switch1 === true">
                      <v-dialog
                        persistent
                        v-model="modal2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            clearable
                            v-bind="attrs"
                            v-on="on"
                            v-model="picker"
                            :label="$t('sharefile.setdate')"
                            readonly
                            prepend-icon="mdi-calendar"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-model="picker"
                          :min="datenow"
                          @input="modal2 = false"
                        >
                          <v-spacer></v-spacer>
                          <v-btn dark color="error" @click="modal2 = false">
                            {{ $t("sharefile.closedatepiker") }}
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex> -->
      <!-- <v-flex lg1 class="pl-5" v-if="switch1 === true && resolutionScreen > 500">
                                <v-divider vertical></v-divider>
                              </v-flex> -->
      <!-- <v-flex lg1 xs1 class="pt-3 pl-2" v-if="switch1 === true">
                                <v-icon>access_time</v-icon>
                              </v-flex> -->
      <!-- <v-flex lg3 xs5 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.sethours')"
                        outlined
                        dense
                        :items="hours"
                        v-model="hour"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex lg3 xs4 v-if="switch1 === true">
                      <v-select
                        class="pl-1"
                        :label="$t('sharefile.setminute')"
                        outlined
                        dense
                        :items="minutes"
                        v-model="minute"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 class="text-left mb-2">
                      <v-subheader class="pl-1">{{
                        $t("sharefile.setpermissionsharefile")
                      }}</v-subheader>
                    </v-flex>
                    <v-flex lg7 xs6 class="ml-2 pl-4">
                      <v-select
                        v-model="status"
                        :items="values"
                        :label="$t('sharefile.Status')"
                        text
                        dense
                        return-object
                        :color="color.theme"
                        :item-color="color.theme"
                        outlined
                      >
                        <template v-slot:item="{ item }">{{
                          $t(item.text)
                        }}</template>
                        <template v-slot:selection="{ item }">{{
                          $t(item.text)
                        }}</template>
                      </v-select>
                    </v-flex>
                    <v-flex lg4 xs4 class="text-right mr-5 pr-2">
                      <v-btn
                        :color="color.theme"
                        :dark="color.darkTheme"
                        :disabled="!loaddataprogress"
                        @click="checktaxid()"
                      >
                        {{ $t("sharefile.share") }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-flex lg11 xs10 v-if="messagetax.length !== 0">
                      <v-subheader class="ml-n3 mb-n2">{{
                        $t("sharefile.sharewith")
                      }}</v-subheader>
                    </v-flex> -->
      <!-- loadingtax -->
      <!-- <v-progress-circular
                      v-if="loaddataprogress === false"
                      indeterminate
                      :color="color.theme"
                      size="100"
                    >
                      <span :style="colorProgress">&nbsp; &nbsp; loading</span>
                    </v-progress-circular> -->
      <!-- Share with tax-->
      <!-- <v-flex lg11 xs9>
                      <v-layout
                        row
                        wrap
                        justify-center
                        pa-1
                        v-for="(item, i) in messagetax"
                        :key="i"
                        class="mb-n4"
                      >
                        <v-flex lg12 xs12 class=" mb-6">
                          <v-divider></v-divider>
                        </v-flex>
                        <v-flex lg7 xs12 class="mb-3">
                          <v-text-field
                            class="pl-2 pr-2"
                            v-if="$t('default') === 'th'"
                            v-model="item.name_th"
                            outlined
                            readonly
                            dense
                            hide-details
                            :color="color.theme"
                            :label="$t('sharefile.business')"
                          ></v-text-field>
                          <v-text-field
                            class="pl-2 pr-2"
                            v-else
                            v-model="item.name_eng"
                            outlined
                            readonly
                            dense
                            hide-details
                            :color="color.theme"
                            :label="$t('sharefile.business')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 xs7 class="mb-3">
                          <v-select
                            class="pl-2"
                            hide-details
                            :items="values"
                            :label="$t('sharefile.Status')"
                            v-model="statussharetax[i]"
                            outlined
                            dense
                            return-object
                            :color="color.theme"
                            :item-color="color.theme"
                          >
                            <template v-slot:item="{ item }">{{
                              $t(item.text)
                            }}</template>
                            <template v-slot:selection="{ item }">{{
                              $t(item.text)
                            }}</template>
                          </v-select>
                        </v-flex>
                        <v-flex lg1 xs5 class="pt-2 text-center">
                          <v-icon
                            color="red"
                            @click="
                              (itemdelete = item),
                                (openconfirmcancelusersharefile = true)
                            "
                            >delete</v-icon
                          >
                        </v-flex>
                        <v-flex lg6 xs12 class="mb-n3">
                          <v-dialog
                            persistent
                            v-model="taxfromdate"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="
                                  pickertax[i] === '' || null
                                    ? setdate(item.number_of_days)
                                    : formatdatetextfield(pickertax[i])
                                "
                                :label="$t('sharefile.setdate')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                clearable
                                v-on="on"
                                outlined
                                dense
                                class="pl-2 pr-2"
                                @click="checkpicker = i"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="pickertax[checkpicker]"
                              :min="datenow"
                              @input="taxfromdate = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dark
                                color="error"
                                @click="taxfromdate = false"
                              >
                                {{ $t("sharefile.closedatepiker") }}
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex> -->
      <!-- <v-flex lg1 class="pl-6 pt-3">
                                    <v-divider vertical></v-divider>
                                  </v-flex> -->
      <!-- <v-flex lg1 xs1 class="pt-4 pl-2" >
                              <v-icon>access_time</v-icon>
                            </v-flex> -->
      <!-- <v-flex lg3 xs6>
                          <v-select
                            :label="$t('sharefile.sethours')"
                            class="pl-0 pr-0"
                            :items="hours"
                            v-model="hourtax[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                        <v-flex lg3 xs5 ml-1>
                          <v-select
                            class=" pr-0"
                            :label="$t('sharefile.setminute')"
                            :items="minutes"
                            v-model="minutetax[i]"
                            outlined
                            dense
                          >
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions v-if="opentabs === 0" style="padding:12px">
            <v-spacer></v-spacer>
            <v-btn
              small
              color="red"
              outlined
              @click="
                $emit('closesharefile'),
                  closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = [])
              "
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              :color="color.theme"
              class="white--text"
              :disabled="checkbuttonupdate"
              @click="editapi()"
              :loading="processloading"
              >{{ $t("sharefile.oksharefile") }}</v-btn
            >
          </v-card-actions>

          <v-card-actions v-if="opentabs === 1" style="padding:12px">
            <v-spacer></v-spacer>
            <v-btn
              small
              color="red"
              outlined
              @click="
                $emit('closesharefile'),
                  closevalues(),
                  (setdatetime = []),
                  (minute2 = []),
                  (minutetax = []),
                  (hour2 = []),
                  (hourtax = []),
                  (picker = ''),
                  (minute = ''),
                  (hour = ''),
                  (switch1 = false),
                  (message = []),
                  (messagetax = [])
              "
              >{{ $t("uploadfolder.buttonclose") }}</v-btn
            >
            <v-btn
              :color="color.theme"
              class="white--text"
              :disabled="checkbuttonupdate"
              @click="editapi()"
              :loading="processloading"
              >{{ $t("sharefile.oksharefile") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-row>
    <!-- <editsharefile
      :editdialog="editsharefile"
      @closesharefile="editsharefile= false"
      :filedata="filedata"
    ></editsharefile>-->
    <confirmcancelusersharefile
      :show="openconfirmcancelusersharefile"
      :filedata="itemdelete"
      :typedata="filedata.file_type === 'folder' ? 'folder' : 'file'"
      @confirmemail="
        deletemessage(itemdelete), (openconfirmcancelusersharefile = false)
      "
      @confirmtax="
        deletemessagetax(itemdelete), (openconfirmcancelusersharefile = false)
      "
      @closesharefile="openconfirmcancelusersharefile = false"
    ></confirmcancelusersharefile>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import dialogLoginssoVue from "./dialog-loginsso.vue";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import format from "date-fns/format";
const editsharefile = () => import("../optional/dialog-editsharefile");
const confirmcancelusersharefile = () =>
  import("../optional/dialog-confirmcancelusersharefile");
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "filedata"],
  components: { editsharefile, confirmcancelusersharefile },
  data: function() {
    return {
      deletingItems: [],
      listgroup_data_normal: [],
      listgroup_data: [],
      list_id: [],
      detail_group: false,
      itemdelete: [],
      openconfirmcancelusersharefile: false,
      datenow: "",
      emailformdate: false,
      taxfromdate: false,
      fakedate: "2000-01-01",
      processloading: false,
      loaddataprogress: false,
      sethour: "",
      setminute: "",
      switch1: false,
      checkpicker: 0,
      menu2: [],
      menutex: [],
      typeshare: "thai_email",
      typeshare_data: "",
      dateymd: "",
      datehour: "",
      dateminute: "",
      datetimecheck: "",
      datetimecheck2: "",
      minute: "",
      hour: "",
      minute2: [],
      minutetax: [],
      hour2: [],
      hourtax: [],
      hours: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      minutes: [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
      ],
      time: "",
      modal2: false,
      modal: false,
      editdate: "",
      edithour: "",
      editmin: "",
      picker: "",
      picker2: [],
      pickertax: [],
      taxid: "",
      item: "",
      setdates: "",
      opentabs: 0,
      setdatetime: [],
      message: [],
      group_mail_list: [],
      messagetax: [],
      statusshare: [],
      statussharetax: [],
      statusshare_: [],
      status: { name: "view", key: "V", text: "sharefile.view" },
      showdialog: false,
      email: "",
      emailadd: [],
      dataset: [],
      statusclosereload: false,
      // defaultSelected:  { name: "view", key: "V", text: "sharefile.view" },
      values: [
        { name: "view", key: "V", text: "sharefile.view" },
        { name: "download", key: "DO", text: "sharefile.download" },
        { name: "upload", key: "U", text: "sharefile.upload" },
        { name: "edit", key: "E", text: "sharefile.edit" },
        { name: "delete", key:"De", text:"sharefile.delete" },
      ],
      editsharefile: false,
      listtypeshare: [
        {
          listtypeshare_type: "วัน อีเมล (One Email)",
          listtypeshare_type_eng: "One Email",
          listtypeshare_value: "thai_email",
        },
        {
          listtypeshare_type: "ผู้ใช้งาน (Username)",
          listtypeshare_type_eng: "Username",
          listtypeshare_value: "username",
        },
        {
          listtypeshare_type: " One Collaboration Email",
          listtypeshare_type_eng: " One Collaboration Email",
          listtypeshare_value: "one_collab_mail",
        },
      ],
    };
  },
  computed: {
    ...mapState(["username", "authorize", "account_active", "color"]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    // style อักษร header ของ mobile
    headerPage() {
      return (
        "color:" +
        this.color.theme +
        ";" +
        "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
      );
    },
    // style อักษรใน dialog ของ mobile
    titleText() {
      return "color:black; font-size: 14px; line-height: 22px;";
    },
    // style ปุ่ม ของ mobile
    btnAction() {
      return "font-size: 16px; font-weight: lighter;";
    },
    // ความกว้างของ dialog ของ ipad และ mobile
    maxWidthOnMobile() {
      if(this.resolutionScreen >= 400) {
        return 600
      } else {
        return 346
      }
    },
    shower: {
      get() {
        if (this.show === true) {
          this.datenow = format(new Date(), "yyyy-MM-dd");
          // this.opentabs = 0
          this.loaddata();
          this.loaddatataxid();
          console.log("testloadshare");
          // if (this.opentabs === 0) {
          //   this.loaddata();
          // } else {
          //   this.loaddatataxid();
          // }
          this.$emit("closeDrag");
        } else {
          this.statusclosereload = false;
        }
        return this.show;
      },
    },
    colorProgress() {
      return "color:" + this.color.theme + ";";
    },
    checkbuttonupdate() {
      if (this.opentabs === 0) {
        console.log("this.statusshare", this.statusshare);
        if (this.statusshare.length == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        console.log("this.statussharetax", this.statussharetax);
        if (this.statussharetax.length == 0) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  methods: {
    settimeminute(_date) {
      let dateminute = _date.split("")[10] + _date.split("")[11];
      return dateminute;
    },
    settimehour(_date) {
      let datehour = _date.split("")[8] + _date.split("")[9];
      return datehour;
    },
    setdate(_date) {
      let dateyear =
        _date.split("")[0] +
        _date.split("")[1] +
        _date.split("")[2] +
        _date.split("")[3];

      let datemount = _date.split("")[4] + _date.split("")[5];

      let dateday = _date.split("")[6] + _date.split("")[7];
      // this.setdatetime.push(dateday + "-" +datemount+ "-" + dateyear)
      console.log(dateday + "-" + datemount + "-" + dateyear);
      return dateday + "-" + datemount + "-" + dateyear;
    },
    checkdatetime() {
      console.log(this.picker, this.hour, this.minute);
      if (this.picker !== "") {
        let dateyear =
          this.picker.split("")[0] +
          this.picker.split("")[1] +
          this.picker.split("")[2] +
          this.picker.split("")[3];

        let datemount = this.picker.split("")[5] + this.picker.split("")[6];
        let dateday = this.picker.split("")[8] + this.picker.split("")[9];
        this.dateymd = dateyear + datemount + dateday;
      } else {
        this.dateymd = "00000000";
      }
      if (this.hour !== "") {
        this.datehour = this.hour.split("")[0] + this.hour.split("")[1];
      } else {
        this.datehour = "00";
      }
      if (this.minute !== "") {
        this.dateminute = this.minute.split("")[0] + this.minute.split("")[1];
      } else {
        this.dateminute = "00";
      }
      let datesecond = "00";

      this.datetimecheck =
        this.dateymd + this.datehour + this.dateminute + datesecond;
      console.log("datetimecheck", this.datetimecheck);
    },
    async checktaxid() {
      if (this.taxid !== "") {
        this.checkdatetime();
        let auth = await gbfGenerate.generateToken();
        let payload;
        console.log(this.filedata.file_type);
        if (this.filedata.file_type === "folder") {
          payload = {
            id: this.filedata.file_id,
            account_id_sender: this.dataAccountId,
            taxid: [
              {
                reciever: this.taxid,
                status: this.status.key,
                date_time: this.datetimecheck,
              },
            ],
          };
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_SHARE_FOLDER +
                "/api/taxid/share_folder_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              console.log(response);
              if (response.data.status === "OK") {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
                this.switch1 = false;
                this.picker = "";
                this.minute = "";
                this.hour = "";
                Toast.fire({
                  icon: "success",
                  title: this.$t("sharefile.sharefoldersuccess"),
                });
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                this.loaddatataxid();
              } else if (response.data.errorCode === "ER404") {
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                Toast.fire({
                  icon: "error",
                  title: this.$t("sharefile.notfoundtaxid"),
                });
              } else {
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                Toast.fire({
                  icon: "error",
                  title: response.data.errorMessage,
                });
              }
            });
        } else {
          let auth = await gbfGenerate.generateToken();
          payload = {
            id: this.filedata.file_id,
            account_id_sender: this.dataAccountId,
            taxid: [
              {
                reciever: this.taxid,
                status: this.status.key,
                date_time: this.datetimecheck,
              },
            ],
          };
          console.log("payload", payload);
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_SHARE_FILE +
                "/api/taxid/share_file_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              console.log(response);
              if (response.data.status === "OK") {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
                this.switch1 = false;
                this.picker = "";
                this.minute = "";
                this.hour = "";
                Toast.fire({
                  icon: "success",
                  title: this.$t("sharefile.sharefilesuccess"),
                });
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                this.loaddatataxid();
              } else if (response.data.errorCode === "ER404") {
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                Toast.fire({
                  icon: "error",
                  title: this.$t("sharefile.notfoundtaxid"),
                });
              } else {
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
                Toast.fire({
                  icon: "error",
                  title: response.data.errorMessage,
                });
              }
            });
        }
      } else {
        Toast.fire({
          icon: "warning",
          // title: "กรุณาระบุเลขประจำตัวผู้เสียภาษี(องกรณ์)ที่ต้องการแชร์"
          title: this.$t("sharefile.emptytaxid"),
        });
      }
    },
    async loaddatataxid(checkempty) {
      this.messagetax = [];
      this.statussharetax = [];
      if (this.filedata.file_type === "folder") {
        let payload = {
          account_id_sender: this.dataAccountId,
          folder_id: this.filedata.file_id,
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FOLDER +
              "/api/taxid/get_sharewith_folder_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            if (response.data.status === "OK") {
              this.loaddataprogress = true;
              console.log(response.data.message);
              this.messagetax = response.data.message;
              for (let i = 0; i < this.messagetax.length; i++) {
                if(this.messagetax[i].status === 'DE' || this.messagetax[i].status === 'De'){
                  this.messagetax[i].status = 'De'
                }
                let data = this.values.find(
                  (V) => V.key === this.messagetax[i]["status"]
                );
                let settime = this.messagetax[i].number_of_days;
                this.statussharetax.push(data);
                this.pickertax.push("");
                this.hourtax.push(this.settimehour(settime));
                this.minutetax.push(this.settimeminute(settime));
                this.menutex.push(false);
              }
              if (checkempty === true) {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
              }
            } else {
              this.loaddataprogress = true;
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              // this.$emit("closesharefile");
            }
          });
      } else {
        let payload = {
          account_id_sender: this.dataAccountId,
          file_id: this.filedata.file_id,
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FILE +
              "/api/taxid/get_sharewith_file_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            if (response.data.status === "OK") {
              this.loaddataprogress = true;
              console.log(response.data.message);
              this.messagetax = response.data.message;
              for (let i = 0; i < this.messagetax.length; i++) {
                if(this.messagetax[i].status === 'DE' || this.messagetax[i].status === 'De'){
                  this.messagetax[i].status = 'De'
                }
                let data = this.values.find(
                  (V) => V.key === this.messagetax[i]["status"]
                );
                let settime = this.messagetax[i].number_of_days;
                this.statussharetax.push(data);
                this.pickertax.push("");
                this.hourtax.push(this.settimehour(settime));
                this.minutetax.push(this.settimeminute(settime));
                this.menutex.push(false);
              }
              if (checkempty === true) {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
              }
            } else {
              this.loaddataprogress = true;
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              // this.$emit("closesharefile");
            }
          });
      }
    },
    async loaddata(checkempty) {
      this.group_mail_list = [];
      this.normol_mail_list = [];
      this.listgroup_data = [];
      this.message = [];
      this.statusshare = [];
      if (this.filedata.file_type === "folder") {
        let getdata = {
          account_id_sender: this.dataAccountId,
          folder_id: this.filedata.file_id,
        };
        let auth = await gbfGenerate.generateToken();

        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FOLDER +
              "/api/get_sharewith_folder_v4",
            getdata,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            if (response.data.status === "OK") {
              this.loaddataprogress = true;
              // console.log("laaaaaa",response.data.message);
              this.group_mail_list = response.data.group_data;
              this.normol_mail_list = response.data.normal_data;

              console.log("group_mail_list", this.group_mail_list);
              console.log("normol_mail_list", this.normol_mail_list);
              // this.message = response.data.message;
              // console.log(response.data);
              for (let i = 0; i < this.normol_mail_list.length; i++) {
                // this.listgroup_data_normal.push(this.normol_mail_list[i])
                this.group_mail_list.push({
                  group_mail: this.normol_mail_list[i],
                });
              }
              console.log("=====", this.group_mail_list);
              for (let i = 0; i < this.group_mail_list.length; i++) {
                if(this.group_mail_list[i]["group_mail"].status === 'DE' || this.group_mail_list[i]["group_mail"].status === 'De'){
                  this.group_mail_list[i]["group_mail"].status = 'De'
                }
                console.log(
                  "***",
                  this.group_mail_list[i]["group_mail"].number_of_days
                );
                let data = this.values.find(
                  (V) =>
                    V.key === this.group_mail_list[i]["group_mail"]["status"]
                );
                // let data_mail = this.values.find((V) => V.key ===  this.group_mail_list[i]["mail_list"]["status"]);
                let settime = this.group_mail_list[i]["group_mail"]
                  .number_of_days;
                this.statusshare.push(data);
                // this.statusshare_.push(data_mail);
                this.picker2.push("");
                this.hour2.push(this.settimehour(settime));
                this.minute2.push(this.settimeminute(settime));
                this.menu2.push(false);
                // let date = this.message[i]["number_of_days"]
                //  this.setdatetime.push(settime)

                this.listgroup_data.push(this.group_mail_list[i]);
              }
              if (checkempty === true) {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
              }
              console.log("listgroup_data", this.listgroup_data);

              // for (let i = 0; i < this.group_mail_list.length; i++) {

              // }

              // for (let i = 0; i < this.group_mail_list.length; i++) {
              //   let data = this.values.find((V) => V.key === this.group_mail_list[i]["status"]);
              //   let settime = this.group_mail_list[i].number_of_days
              //   this.statusshare.push(data);
              //   this.picker2.push("");
              //   this.hour2.push(this.settimehour(settime));
              //   this.minute2.push(this.settimeminute(settime));
              //   this.menu2.push(false);
              //   //  let date = this.message[i]["number_of_days"]
              //   //  this.setdatetime.push(date)
              // }

              // for (let i = 0; i < this.message.length; i++) {
              //   let data_ = this.values.find((V) => V.key === this.message[i]["status"]);
              //   console.log("data_",data_);
              //   let settime_ = this.message[i].number_of_days
              //   this.statusshare_.push(data_);
              //   this.picker2.push("");
              //   this.hour2.push(this.settimehour(settime_));
              //   this.minute2.push(this.settimeminute(settime_));
              //   this.menu2.push(false);

              //   //  let date = this.message[i]["number_of_days"]
              //   //  this.setdatetime.push(date)
              // }
            } else {
              this.loaddataprogress = true;
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              // this.$emit("closesharefile");
            }
          });
      } else {
        let getdata = {
          account_id_sender: this.dataAccountId,
          file_id: this.filedata.file_id,
        };
        let auth = await gbfGenerate.generateToken();
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FILE +
              "/api/get_sharewith_file_v4",
            getdata,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            if (response.data.status === "OK") {
              this.loaddataprogress = true;

              this.group_mail_list = response.data.group_data;
              this.normol_mail_list = response.data.normal_data;

              console.log("group_mail_list", this.group_mail_list);
              console.log("normol_mail_list", this.normol_mail_list);
              // this.message = response.data.message;
              console.log(response.data);
              // for (let i = 0; i < this.message.length; i++) {
              //   let data = this.values.find((V) => V.key === this.message[i]["status"]);
              //   let settime = this.message[i].number_of_days
              //   this.statusshare.push(data);
              //   this.picker2.push("");
              //   this.hour2.push(this.settimehour(settime));
              //   this.minute2.push(this.settimeminute(settime));
              //   this.menu2.push(false);
              //   // let date = this.message[i]["number_of_days"]
              //   //  this.setdatetime.push(date)
              // }
              for (let i = 0; i < this.normol_mail_list.length; i++) {
                // this.listgroup_data_normal.push(this.normol_mail_list[i])
                this.group_mail_list.push({
                  group_mail: this.normol_mail_list[i],
                });
              }
              console.log("=====", this.group_mail_list);
              for (let i = 0; i < this.group_mail_list.length; i++) {
                if(this.group_mail_list[i]["group_mail"].status === 'DE' || this.group_mail_list[i]["group_mail"].status === 'De'){
                  this.group_mail_list[i]["group_mail"].status = 'De'
                }
                console.log(
                  "***",
                  this.group_mail_list[i]["group_mail"].number_of_days
                );
                let data = this.values.find(
                  (V) =>
                    V.key === this.group_mail_list[i]["group_mail"]["status"]
                );
                // let data_mail = this.values.find((V) => V.key ===  this.group_mail_list[i]["mail_list"]["status"]);
                let settime = this.group_mail_list[i]["group_mail"]
                  .number_of_days;
                this.statusshare.push(data);
                // this.statusshare_.push(data_mail);
                this.picker2.push("");
                this.hour2.push(this.settimehour(settime));
                this.minute2.push(this.settimeminute(settime));
                this.menu2.push(false);
                // let date = this.message[i]["number_of_days"]
                //  this.setdatetime.push(settime)

                this.listgroup_data.push(this.group_mail_list[i]);
              }
              if (checkempty === true) {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
              }
            } else {
              this.loaddataprogress = true;
              console.log(response.data.errorMessage);
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              // this.$emit("closesharefile");
            }
          });
      }
    },
    closevalues() {
      this.email = "";
      this.statusshare = [];
      this.statussharetax = [];
      this.status = { name: "view", key: "V", text: "sharefile.view" };
    },
    //  on-button
    async addemailapi(adddata, id, list_id) {
      // let adddata = [];
      //console.log("nnnnn",this.emailadd);
      //for (let i = 0; i < this.emailadd.length; i++) {
      //console.log("LLLLL",this.emailadd[i].id,this.emailadd[i].status.key);
      // adddata.push({
      //   reciever:_id,
      //   status: _key,
      //   date_time: this.datetimecheck,
      //   group_mail:"",
      //   name_shared:"",
      //   type_shared:""
      // });
      // }
      let payload = {
        id: this.filedata.file_id,
        account_id_sender: this.dataAccountId,
        account_id_reciever: adddata,
      };
      console.log("payload addemailapi", payload);
      if (this.filedata.file_type === "folder") {
        let auth = await gbfGenerate.generateToken();
        let response = await this.axios({
          method: "POST",
          url:
            process.env.VUE_APP_SERVICE_SHARE_FOLDER + "/api/share_folder_v4",
          data: payload,
          headers: { Authorization: auth.code },
        });
        return new Promise((resolve, reject) => {
          try {
            if (response.data.status === "OK") {
              this.emailadd = [];
              this.statusshare = [];
              this.switch1 = false;
              this.hour = "";
              this.minute = "";
              this.picker = "";

              setTimeout(() => {
                resolve({ status: "success", msg: "OK", code: "" });
              }, 500);
            } else {
              this.picker = "";
              this.hour = "";
              this.minute = "";
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              setTimeout(() => {
                resolve({ status: "error", msg: "OK", code: "" });
              }, 500);
            }
          } catch (err) {
            setTimeout(() => {
              resolve({ status: "denied", msg: ": " + err, code: "" });
            }, 500);
          }
        });
        // let auth = await gbfGenerate.generateToken();
        // if (this.filedata.file_type === "folder")
        //   this.axios
        //     .post(process.env.VUE_APP_SERVICE_SHARE_FOLDER + "/api/share_folder_v4", payload, {
        //       headers: { Authorization: auth.code },
        //     })
        //     .then((response) => {
        //       if (response.data.status === "OK") {
        //         this.emailadd = [];
        //         this.statusshare = [];
        //         this.switch1 = false;
        //         this.hour = "";
        //         this.minute = "";
        //         this.picker = "";
        //         // this.loaddata();
        //         Toast.fire({
        //           icon: "success",
        //           title: this.$t("sharefile.sharefoldersuccess"),
        //         });
        //         setTimeout(() => {
        //               resolve({ status: "success", msg: "OK", code: "" });
        //                 }, 500);
        //       } else {
        //         this.picker = "";
        //         this.hour = "";
        //         this.minute = "";
        //         Toast.fire({
        //           icon: "error",
        //           title: response.data.errorMessage
        //         });
        //         setTimeout(() => {
        //               resolve({ status: "error", msg: "OK", code: "" });
        //                 }, 500);
        //       }
        //     });
      } else {
        let auth = await gbfGenerate.generateToken();
        let response = await this.axios({
          method: "POST",
          url: process.env.VUE_APP_SERVICE_SHARE_FILE + "/api/share_file_v4",
          data: payload,
          headers: { Authorization: auth.code },
        });
        return new Promise((resolve, reject) => {
          try {
            if (response.data.status === "OK") {
              this.emailadd = [];
              this.statusshare = [];
              this.hour = "";
              this.minute = "";
              this.picker = "";
              this.switch1 = false;

              setTimeout(() => {
                resolve({ status: "success", msg: "OK", code: "" });
              }, 500);
            } else {
              this.hour = "";
              this.minute = "";
              this.picker = "";
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
              setTimeout(() => {
                resolve({ status: "error", msg: "OK", code: "" });
              }, 500);
            }
          } catch (err) {
            setTimeout(() => {
              resolve({ status: "denied", msg: ": " + err, code: "" });
            }, 500);
          }
        });
        // this.axios
        //   .post(process.env.VUE_APP_SERVICE_SHARE_FILE + "/api/share_file_v4", payload, { headers: { Authorization: auth.code } })
        //   .then((response) => {
        //     if (response.data.status === "OK") {
        //       this.emailadd = [];
        //       this.statusshare = [];
        //       this.hour = "";
        //       this.minute = "";
        //       this.picker = "";
        //       this.switch1 = false;
        //       // this.loaddata();
        //       Toast.fire({
        //         icon: "success",
        //         title: this.$t("sharefile.sharefilesuccess"),
        //       });
        //       setTimeout(() => {
        //             resolve({ status: "success", msg: "OK", code: "" });
        //               }, 500);
        //     } else {
        //       this.hour = "";
        //       this.minute = "";
        //       this.picker = "";
        //       Toast.fire({
        //         icon: "error",
        //         title: response.data.errorMessage
        //       });
        //       setTimeout(() => {
        //             resolve({ status: "error", msg: "OK", code: "" });
        //               }, 500);
        //     }
        //   });
      }
    },
    // button share
    async addemail() {
      this.loaddataprogress = false;
      if (this.typeshare_data !== "") {
        let payload = {
          data_type: this.typeshare,
          data_text: this.typeshare_data,
        };
        let i;
        let dflag = this.message.findIndex(
          (v) => v.data_text === this.typeshare_data
        );
        if (dflag == -1) {
          let auth = await gbfGenerate.generateToken();
          this.checkdatetime();
          this.axios
            // .post(process.env.VUE_APP_SERVICE_DOWNLOAD_API + "/api/v2/check_account_bymail", payload, {
            //   headers: { Authorization: auth.code },
            // })
            // apiใหม่
            .post(
              process.env.VUE_APP_SERVICE_DOWNLOAD_API +
                "/api/v1/check_account_oneid",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              if (this.typeshare_data == "") {
                Toast.fire({
                  icon: "warning",
                  title: this.$t("sharefile.pleasefill_email"),
                });
              } else if (response.data.status === "OK") {
                if (this.statusshare.length === 0 && this.statussharetax.length === 0) {
                  this.statusclosereload = true;
                }
                console.log("==res", response.data.data);
                this.list_id = response.data.data;
                this.fn_loopshare(this.list_id);
                // this.id = response.data.result["id"];
                // this.emailadd.push({
                //   id: this.id,
                //   email: this.email,
                //   status: this.status,
                // });
                /////////////
                //  let adddata = [];
                //   for(let i=0; i < this.list_id.length; i++){
                //     adddata.push({
                //     reciever: this.list_id[i].id,
                //     status: this.status.key,
                //     date_time: this.datetimecheck,
                //     group_mail: this.list_id[i].group_mail,
                //     name_shared:this.list_id[i].name_shared,
                //     type_shared:this.list_id[i].type_shared
                //   });
                //   console.log("adddata",adddata);
                //   }

                //   // this.addemailapi(this.id,this.status.key,);
                //    await this.addemailapi(adddata, this.list_id[i].id).then(async (res) => {
                //     if(res.status === "delete success"){
                //       console.log("yess");
                //     }else{
                //       console.log("nooo");
                //     }
                //   });
                //   this.typeshare_data = "";
                //   this.status = { name: "view", key: "V", text: "sharefile.view" };
              } else if (response.data.errorCode === "ER400") {
                this.loaddataprogress = true;
                // ไม่พบอีเมล เมื่อทำการแชร์ร่วมกัน
                if(this.typeshare === "thai_email"){
                Toast.fire({
                  icon: "error",
                  title: this.$t("sharefile.notfoundemail"),
                });
                // ไม่พบผู้ใช้งาน เมื่อทำการแชร์ร่วมกัน
                }else if(this.typeshare === "username"){
                Toast.fire({
                  icon: "error",
                  title: this.$t("sharefile.notfoundusername"),
                });
                // ไม่พบ onecollabmail เมื่อทำการแชร์ร่วมกัน
                }else{
                  Toast.fire({
                  icon: "error",
                  title: this.$t("sharefile.notfoundonecollabmail"),
                });
                }
              } else {
                this.loaddataprogress = true;
                Toast.fire({
                  icon: "error",
                  title: response.data.errorMessage,
                });
              }
            });
        } else {
          this.loaddataprogress = true;
          Toast.fire({
            icon: "error",
            title: this.$t("sharefile.cannotemail"),
          });
        }
      } else {
        this.loaddataprogress = true;
        if (this.typeshare === "thai_email") {
          Toast.fire({
            icon: "warning",
            // title: "กรุณากรอกอีเมล"
            title: this.$t("sharefile.pleasefill_email"),
          });
        } else if (this.typeshare === "username") {
          Toast.fire({
            icon: "warning",
            // title: "กรุณากรอกชื่อผู้ใช้งาน"
            title: this.$t("sharefile.pleasefill_username"),
          });
        } else if (this.typeshare === "one_collab_mail") {
          Toast.fire({
            icon: "warning",
            // title: "กรุณากรอก one_collab"
            title: this.$t("sharefile.pleasefill_onecollab"),
          });
        } else {
          Toast.fire({
            icon: "warning",
            // title: "กรุณาเลือกประเภทผู้ใช้งาน"
            title: this.$t("sharefile.pleasefill_type"),
          });
        }
      }
    },
    async fn_loopshare(list_id) {
      console.log("list_id fn_loopshare", list_id);
      let adddata = [];
      for (let i = 0; i < list_id.length; i++) {
        adddata.push({
          reciever: list_id[i].id,
          status: this.status.key,
          date_time: this.datetimecheck,
          group_mail: list_id[i].group_mail,
          name_shared: list_id[i].name_shared,
          type_shared: list_id[i].type_shared,
        });
        console.log("adddata", adddata);
        await this.addemailapi(adddata, list_id[i].id, list_id).then(
          async (res) => {
            if (res.status === "success") {
              adddata = [];
              console.log("yess");
              if (list_id.length - i === 1) {
                this.loaddataprogress = true;
                this.loaddata();
                Toast.fire({
                  icon: "success",
                  title:
                    list_id[i].group_mail +
                    this.$t("sharefile.sharefoldersuccess"),
                });
              }
            } else {
              this.loaddataprogress = true;
              console.log("nooo");
              adddata = [];
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
          }
        );
      }

      this.typeshare_data = "";
      this.status = { name: "view", key: "V", text: "sharefile.view" };
    },
    // Delete data
    async deletemessagetax(item) {
      console.log("deltax", item);
      const itemId = item.account_id_reciever;
      this.deletingItems.push(itemId);
      let datachild = [];
      datachild.push({ taxid: item.taxid });
      let payload = {
        id: this.filedata.file_id,
        account_id: this.dataAccountId,
        remove: datachild,
      };
      let auth = await gbfGenerate.generateToken();
      console.log(this.filedata.file_type);
      if (this.filedata.file_type === "folder") {
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FOLDER +
              "/api/taxid/delete_sharing_folder_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status === "OK") {
              this.loaddatataxid(true);
              Toast.fire({
                icon: "success",
                title: this.$t("sharefile.deletesuc"),
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
            this.deletingItems = this.deletingItems.filter(id => id !== itemId);
          });
      } else {
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FILE +
              "/api/taxid/delete_sharing_file_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status === "OK") {
              this.loaddatataxid(true);
              Toast.fire({
                icon: "success",
                title: this.$t("sharefile.deletesuc"),
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
            this.deletingItems = this.deletingItems.filter(id => id !== itemId);
          });
      }
    },
    async deletemessage(item) {
      console.log("-------", item);
      const itemId = item.account_id_reciever;
      this.deletingItems.push(itemId);
      let datachild = [];
      datachild.push({
        child:
          item.account_id_reciever !== undefined
            ? item.account_id_reciever
            : "",
        group_mail:
          item.group_mail !== undefined ? item.group_mail : item.name_th,
        type_shared: item.type_shared,
      });
      let payload = {
        id: this.filedata.file_id,
        account_id: this.dataAccountId,
        remove: datachild,
      };
      console.log("payload", payload);
      let auth = await gbfGenerate.generateToken();
      if (this.filedata.file_type === "folder") {
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FOLDER +
              "/api/delete_sharing_folder_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data.status === "OK") {
              this.loaddata(true);
              Toast.fire({
                icon: "success",
                title: this.$t("sharefile.deletesuc"),
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
            this.deletingItems = this.deletingItems.filter(id => id !== itemId);
          });
      } else {
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SHARE_FILE +
              "/api/delete_sharing_file_v4",
            payload,
            {
              headers: { Authorization: auth.code },
            }
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data.status === "OK") {
              this.loaddata(true);
              Toast.fire({
                icon: "success",
                title: this.$t("sharefile.deletesuc"),
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
            this.deletingItems = this.deletingItems.filter(id => id !== itemId);
          });
      }
    },
    isItemDeleting(item) {
      return this.deletingItems.includes(item.account_id_reciever);
    },
    deldatatax(item) {
      Swal.fire({
        title: "คุณต้องการลบ?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ใช่",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletemessagetax(item);
        }
      });
    },
    deldata(item) {
      Swal.fire({
        title: "คุณต้องการลบ?",
        // text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ใช่",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletemessage(item);
        }
      });
    },
    formatdatetextfield(_date) {
      // console.log("test date", _date);
      if (_date === "" || _date === null || _date === undefined) {
        return "";
      } else {
        let dateyear =
          _date.split("")[0] +
          _date.split("")[1] +
          _date.split("")[2] +
          _date.split("")[3];
        let datemount = _date.split("")[5] + _date.split("")[6];
        let dateday = _date.split("")[8] + _date.split("")[9];
        return dateday + "-" + datemount + "-" + dateyear;
      }
    },
    formatdate(_date) {
      console.log("format1-----------", _date);
      if (_date === "") {
        return "";
      } else {
        let dateyear =
          _date.split("")[0] +
          _date.split("")[1] +
          _date.split("")[2] +
          _date.split("")[3];

        let datemount = _date.split("")[5] + _date.split("")[6];

        let dateday = _date.split("")[8] + _date.split("")[9];
        // this.setdatetime.push(dateday + "-" +datemount+ "-" + dateyear)
        console.log("format2-----------------", dateyear + datemount + dateday);

        return dateyear + datemount + dateday;
      }
    },
    formathour(_hour) {
      console.log("_hour", _hour);
      if (_hour === "") {
        this.sethour = "";
      } else {
        this.sethour = _hour.split("")[0] + _hour.split("")[1];
      }
      console.log("_hour2", this.sethour);
      return this.sethour;
    },
    formatminute(_minute) {
      console.log("_minute", _minute);
      if (_minute === "") {
        this.setminute = "";
      } else {
        this.setminute = _minute.split("")[0] + _minute.split("")[1];
      }
      console.log("_minute2", this.setminute);
      return this.setminute;
    },
    // button updates
    async editapi() {
      if (this.opentabs === 0) {
        let dataarray = [];
        this.processloading = true;
        console.log("listgroup_data==", this.listgroup_data);
        console.log("listgroup_data==", this.listgroup_data.group_mail);

        for (let i = 0; i < this.listgroup_data.length; i++) {
          // checkdate
          if (this.formatdate(this.picker2[i]) === "") {
            this.editdate = this.listgroup_data[
              i
            ].group_mail.number_of_days.slice(0, 8);
            // this.editdate = this.message[i].number_of_days.slice(0, 8);
          } else {
            this.editdate = this.formatdate(this.picker2[i]);
          }
          //  checkhour
          if (this.formathour(this.hour2[i]) === "") {
            this.edithour = this.listgroup_data[
              i
            ].group_mail.number_of_days.slice(8, 10);
          } else {
            this.edithour = this.formathour(this.hour2[i]);
          }
          // checkmin
          if (this.formatminute(this.minute2[i]) === "") {
            this.editmin = this.listgroup_data[
              i
            ].group_mail.number_of_days.slice(10, 12);
          } else {
            this.editmin = this.formatminute(this.minute2[i]);
          }
          console.log(
            "-----------------",
            this.editdate + this.edithour + this.editmin
          );
          console.log("-group_mail--", this.listgroup_data[i].group_mail);
          dataarray.push({
            child:
              this.listgroup_data[i].group_mail.type_shared !== "3"
                ? this.listgroup_data[i].group_mail.account_id_reciever
                : "",
            status: this.statusshare[i].key,
            date_time: this.editdate + this.edithour + this.editmin + "00",
            group_mail:
              this.listgroup_data[i].group_mail.type_shared === "3"
                ? this.listgroup_data[i].group_mail.name_th
                : "",
          });
        }
        let payload = {
          id: this.filedata.file_id,
          account_id: this.dataAccountId,
          array: dataarray,
        };
        if (this.filedata.file_type === "folder") {
          let auth = await gbfGenerate.generateToken();
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_UPDATE_FOLDER +
                "/api/update_folder_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              if (response.data.status === "OK") {
                this.processloading = false;
                this.$emit("closesharefile");
                this.email = "";
                this.hour2 = [];
                this.minute2 = [];
                this.picker2 = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
              } else {
                this.processloading = false;
                // this.$emit("closesharefile");
                this.email = "";
                this.hour2 = [];
                this.minute2 = [];
                this.picker2 = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                console.log(response.data.errorMessage);
                Toast.fire({
                  icon: "error",
                  title:
                    response.data.errorCode + ": " + response.data.errorMessage,
                });
              }
            });
        } else {
          let auth = await gbfGenerate.generateToken();
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_UPDATE_FILE + "/api/update_file_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              if (response.data.status === "OK") {
                this.processloading = false;
                this.$emit("closesharefile");
                this.email = "";
                this.hour2 = [];
                this.minute2 = [];
                this.picker2 = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
              } else {
                this.processloading = false;
                // this.$emit("closesharefile");
                this.email = "";
                this.hour2 = [];
                this.minute2 = [];
                this.picker2 = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                console.log(response.data.errorMessage);
                Toast.fire({
                  icon: "error",
                  title:
                    response.data.errorCode + ": " + response.data.errorMessage,
                });
              }
            });
        }
      } else {
        this.processloading = true;
        let dataarray = [];
        for (let i = 0; i < this.messagetax.length; i++) {
          console.log(
            "this.messagetax[i].number_of_days.slice(0,8)",
            this.messagetax[i].number_of_days.slice(0, 8)
          );
          console.log(
            "this.formatdate(this.pickertax[i]) ใหม่",
            this.formatdate(this.pickertax[i])
          );
          // checkdate
          if (this.formatdate(this.pickertax[i]) === "") {
            this.editdate = this.messagetax[i].number_of_days.slice(0, 8);
          } else {
            this.editdate = this.formatdate(this.pickertax[i]);
          }
          //  checkhour
          if (this.formathour(this.hourtax[i]) === "") {
            this.edithour = this.messagetax[i].number_of_days.slice(8, 10);
          } else {
            this.edithour = this.formathour(this.hourtax[i]);
          }
          // checkmin
          if (this.formatminute(this.minutetax[i]) === "") {
            this.editmin = this.messagetax[i].number_of_days.slice(10, 12);
          } else {
            this.editmin = this.formatminute(this.minutetax[i]);
          }
          dataarray.push({
            taxid: this.messagetax[i].taxid,
            status: this.statussharetax[i].key,
            date_time: this.editdate + this.edithour + this.editmin + "00",
          });
        }
        let payload = {
          id: this.filedata.file_id,
          account_id: this.dataAccountId,
          taxid: dataarray,
        };
        let auth = await gbfGenerate.generateToken();
        console.log("payloadtax", payload);
        if (this.filedata.file_type === "folder") {
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_UPDATE_FOLDER +
                "/api/taxid/update_folder_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              if (response.data.status === "OK") {
                this.processloading = false;
                this.$emit("closesharefile");
                this.hourtax = [];
                this.minutetax = [];
                this.pickertax = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
              } else {
                this.processloading = false;
                // this.$emit("closesharefile");
                this.hourtax = [];
                this.minutetax = [];
                this.pickertax = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                console.log(response.data.errorMessage);
                Toast.fire({
                  icon: "error",
                  title:
                    response.data.errorCode + ": " + response.data.errorMessage,
                });
              }
            });
        } else {
          let auth = await gbfGenerate.generateToken();
          this.axios
            .post(
              process.env.VUE_APP_SERVICE_UPDATE_FILE +
                "/api/taxid/update_file_v4",
              payload,
              {
                headers: { Authorization: auth.code },
              }
            )
            .then((response) => {
              if (response.data.status === "OK") {
                this.processloading = false;
                this.$emit("closesharefile");
                this.hourtax = [];
                this.minutetax = [];
                this.pickertax = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                this.taxid = "";
                this.status = {
                  name: "view",
                  key: "V",
                  text: "sharefile.view",
                };
              } else {
                this.processloading = false;
                // this.$emit("closesharefile");
                this.hourtax = [];
                this.minutetax = [];
                this.pickertax = [];
                this.picker = "";
                this.minute = "";
                this.hour = "";
                this.switch1 = false;
                console.log(response.data.errorMessage);
                Toast.fire({
                  icon: "error",
                  title:
                    response.data.errorCode + ": " + response.data.errorMessage,
                });
              }
            });
        }
      }
    },
  },
};
</script>
<style>
#thiscontainer {
  height: calc(101vh - 180px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -moz-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
}
.scroller {
  height: 300px;
  overflow-y: scroll;
  scrollbar-color: rebeccapurple green;
  scrollbar-width: thin;
  overflow-x: hidden;
}
</style>
